/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvcGFnZXMvYWRtaW4vaWNvbnRhY3Qvc2V0dGluZy9hY2NvdW50L3VzZXIvdXNlci5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL1VzZXJzL3F1YW5ob2FuZy96ZW5pZnkvcmVwb3MvY2xpZW50LWZpbmFsL3NyYy9hcHAvcGFnZXMvYWRtaW4vaWNvbnRhY3Qvc2V0dGluZy9hY2NvdW50L3VzZXIvdXNlci5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/pages/admin/icontact/setting/account/user/user.component.css.shim.ngstyle.ts